import React, { Component } from 'react';

export const CurrentPathContext = React.createContext({});

export class CurrentPathProvider extends Component {

    constructor(props) {
        super(props);
    }


	/**
	 * The render function
	 */
    render() {
        const { children } = this.props;
        
        return (
            <CurrentPathContext.Provider
                value={{
                    currentPath: this.props.currentPath
                }}
            >
                {children}
            </CurrentPathContext.Provider>
        );
    }
}

//export const CurrentPathConsumer = CurrentPathContext.Consumer;
